import { render, staticRenderFns } from "./setpassword.vue?vue&type=template&id=74238746&scoped=true&"
import script from "./setpassword.vue?vue&type=script&lang=js&"
export * from "./setpassword.vue?vue&type=script&lang=js&"
import style0 from "./setpassword.vue?vue&type=style&index=0&id=74238746&less=true&scoped=true&lang=css&"
import style1 from "./setpassword.vue?vue&type=style&index=1&less=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74238746",
  null
  
)

export default component.exports